/*
    sidebar component should be a component usable for all main views
*/
import React, {useState, useEffect} from 'react';
import { rbac } from '../../index';
import t from '../../../../helpers/t';
import NewMessageButton from './NewMessageButton';
import {ListItem} from "../../styled_components/exporter";
import {$, moment, DropdownButton, Dropdown} from "../../../../../../vendor";
import {getApiHost} from "../../../../../Sync";
import {Biscuit, getAllUrlParams} from "../../../../../utils";
import * as FileSaver from "../../../../../../vendor/FileSaver";
import SidebarFilter from '../../../../components/SidebarFilter';
import {useSelector, userActions, membershipTypeActions} from "inbooma-api";
import {getFilterData} from "../../../../../utils/Helper";
import Paginator from "../../../../components/paginator";

const MessageSidebar = (props) => {
    
    const currentUrl = new URL(window.location.href)
    const searchParams = currentUrl.searchParams;
    const allUrlParams = getAllUrlParams(window.location.href)
    allUrlParams?.fullname !== null && delete allUrlParams.fullname;
    allUrlParams?.usergroup !== null && delete allUrlParams.usergroup;
    const [globalFilter, setGlobalFilter] = useState({});           // set empty object, there are no filters set by default
    
    const [statusFilter, setStatusFilter] = useState({value: searchParams.get("mstatus") !== null ? searchParams.get("mstatus") : "all"});       // 'all', 'active', 'inactive'
    const [notificationFilter, setNotificationFilter] = useState({value: searchParams.get("mtype") !== null ? searchParams.get("mtype") : "all"});       // 'all', 'email', 'push', 'sms'
    const [selectedUser,setSelectedUser] = useState((searchParams.get("fullname") !== null && searchParams.get("q") !== null) ? {value: searchParams.get("q"), label: searchParams.get("fullname")} : null);
    const [selectedUserGroup,setSelectedUserGroup] = useState((searchParams.get("usergroup") !== null && searchParams.get("user_group_id") !== null) ? {value: searchParams.get("user_group_id"), label: searchParams.get("usergroup")} : null);
    const [userGroups,setUserGroups] = useState([]);
    const [users,setUsers] = useState([]);
    const [selectedDateFrom,setSelectedDateFrom] = useState(searchParams.get("created_gte") !== null ? moment(searchParams.get("created_gte"), 'YYYY-MM-DD').toDate() : null);
    const [selectedDateTo,setSelectedDateTo] = useState(searchParams.get("created_lte") !== null ? moment(searchParams.get("created_lte"), 'YYYY-MM-DD').toDate() : null);
    const [usedFilterCount,setUsedFilterCount] = useState({messageStatusFilter:allUrlParams?.mstatus !== undefined ? true : false, messageNotificationFilter: allUrlParams?.mtype !== undefined ? true : false, userIdFilter: allUrlParams?.q !== undefined ? true : false, userGroupFilter: allUrlParams?.user_group_id !== undefined ? true : false, dateFromFilter:allUrlParams?.created_gte !== undefined ? true : false, dateToFilter:allUrlParams?.created_lte !== undefined ? true : false});
    const [filterCount,setFilterCount] = useState(Object.keys(allUrlParams).length > 0 ? Object.keys(allUrlParams).length : 0);
    const [usersPending,setUsersPending] = useState(false);
    const _users = useSelector(state => state.users_data.users);
    const _userGroups = useSelector(state => state.membership_types_data.membershipTypes);
    const cleanState = {messageStatusFilter:false, messageNotificationFilter: false, dateFromFilter:false, dateToFilter:false};
    const [selectedItems, setSelectedItems] = useState((searchParams.get("fullname") !== null && searchParams.get("q") !== null) ? {value: searchParams.get("q"), label: searchParams.get("fullname")} : []);
    let language = Biscuit.get('user.lang').replace('-','_');
    useEffect(() => {

        if (_users.success === "") return;
    
        if (_users.success === true) {
            if(_users.data.length){
                let userArray = [];
                _users.data.map(user => {
                    userArray.push({value: user.id,label: user.first_name + ' ' + user.last_name});
                });
                setUsers(userArray);
            }else{
                setUsers([]);
            }

        } else if (_users.success === false) {
            console.log("Failed to request users!");
        }
        setUsersPending(false);
    },[_users]);

    useEffect(() => {

        if (_userGroups.success === "") return;
    
        if (_userGroups.success === true) {
            if(_userGroups.data.length){
                let userArray = [];
                _userGroups.data.map(usergroup => {
                    userArray.push({value: usergroup.id,label: usergroup.name});
                });
                setUserGroups(userArray);
            }else{
                setUserGroups([]);
            }

        } else if (_userGroups.success === false) {
            console.log("Failed to request usergroups!");
        }
        setUsersPending(false);
    },[_userGroups]);

    const onToggleLeftBar = (ev) => {

        $('#inb-c-sidebar').toggleClass('open');
        $('html,body').scrollTop(0);
    };

    const onStatusFilterChange = (val) => {

        setStatusFilter({value: val});                  // set status filter
        var clone2 = {...usedFilterCount};
        var clone = {};
        Object.assign(clone,globalFilter);  
        // get current filter settings (all filter)

        if (val == 'all') {
            // remove status filter from global filter
            clone2.messageStatusFilter = false;
            delete clone['mstatus'];
        } else {
            clone2.messageStatusFilter = true;
            clone.mstatus = val;
        }
        setUsedFilterCount(clone2);
        onFilterCountChangeHandle(clone2);
        setGlobalFilter(clone);
        props.setSelectedFilter(clone);                 // cloned object must be used because global filter is not yet updated
        // parsedUrl.searchParams.append('notification_status', val);
        if(val !== "all"){
            searchParams.set('mstatus', val);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }else{
            searchParams.delete('mstatus');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
    };

    const onNotificationFilterChange = (val) => {

        setNotificationFilter({value: val});   
        var clone2 = {...usedFilterCount};
        // set status filter
        var clone = {};
        Object.assign(clone,globalFilter);              // get current filter settings (all filter)

        if (val == 'all') {
            // remove notification filter from global filter
            clone2.messageNotificationFilter = false;
            delete clone['mtype'];
        } else {
            clone2.messageNotificationFilter = true;
            clone.mtype = val;
        }
        setUsedFilterCount(clone2);
        onFilterCountChangeHandle(clone2);
        setGlobalFilter(clone);
        props.setSelectedFilter(clone);                 // cloned object must be used because global filter is not yet updated
        if(val !== "all"){
            searchParams.set('mtype', val);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }else{
            searchParams.delete('mtype');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
    };

    const onUserQueryHandle = (query) => {

        // start dispatch of user query
        props.dispatch(userActions.getUsers({
            token: Biscuit.get('token'),
            filter: {
                findForSelect: true,
                find: 'short',
                limit: 999,
                page: 1,
                n: query
            },
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setUsersPending(true);
    };

    const onUserSelectHandle = (item, fetch = true) => {
        // should validate filter combination and start request
        var clone = {...globalFilter};
        var clone2 = {...usedFilterCount};
        if (item === null || typeof item.id === 'undefined' || item.id === null){
            delete clone.q;
            clone2.userIdFilter = false;
            setSelectedUser(null);
            setSelectedItems([]);
        } else{
            const user = {label: item.name, value: item.id};
            clone.q = item.id;
            clone2.userIdFilter = true;
            setSelectedUser(user);
            setSelectedItems(user);
        }
        setUsedFilterCount(clone2);
        setGlobalFilter(clone);
        onFilterCountChangeHandle(clone2);
        // fetch users corresponding to the letter the user typed
        if(fetch) {
            props.setSelectedFilter(clone);
        }
        if(item !== null && item.id !== null){
            const user = {label: item.name, value: item.id};
            searchParams.set('q', user.value);
            searchParams.set('fullname', user.label);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }else{
            searchParams.delete('q');
            searchParams.delete('fullname');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
    };

    const onUserGroupQueryHandle = (query) => {

        // start dispatch of usergroup query
        props.dispatch(membershipTypeActions.getMembershipTypes({
            token: Biscuit.get('token'),
            filter: {
                findForSelect: true,
                find: 'short',
                limit: 999,
                page: 1,
                n: query
            },
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        })); 
    };

    const onUserGroupSelectHandle = (id, name, fetch = true) => {
        const usergroup = {label: name, value: id};
        // should validate filter combination and start request
        var clone = {...globalFilter};
        var clone2 = {...usedFilterCount};
        if (typeof id === 'undefined' || id === null){
            delete clone.user_group_id;
            clone2.userGroupFilter = false;
            setSelectedUserGroup(null);
        } else{
            clone.user_group_id = id;
            clone2.userGroupFilter = true;
            setSelectedUserGroup(usergroup);
        }
        setUsedFilterCount(clone2);
        setGlobalFilter(clone);
        onFilterCountChangeHandle(clone2);
        // fetch usergroups corresponding to the letter the user typed
        if(fetch) {
            props.setSelectedFilter(clone);
        }
        if(id !== null){
            searchParams.set('user_group_id', usergroup.value);
            searchParams.set('usergroup', usergroup.label);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }else{
            searchParams.delete('user_group_id');
            searchParams.delete('usergroup');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
    };

    const onFilterCountChangeHandle = (value) => {
        let clone = {...value};
        let count = 0;
        for (const [type,val] of Object.entries(clone)) {
            if(val){
                count++;
            }
        }
        if(count < 1){
            count = 0;
            $('#inb-selected-filters').addClass('hidden');
        } else {
            $('#inb-selected-filters').removeClass('hidden');
        }
        setFilterCount(count);

    };

    const selectedDateFromHandle = (date, fetch = true) => {
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if(date === null){
            if(typeof clone.created_gte !== 'undefined'){
                delete clone.created_gte;
            }
            clone2.dateFromFilter = false;
            $('.messages_from').removeClass('active');
        } else {
            clone.created_gte = moment(date).format('YYYY-MM-DD 00:00:00');
            $('.messages_from').addClass('active');
            clone2.dateFromFilter = true;
        }
        setGlobalFilter(clone);
        setUsedFilterCount(clone2);
        setSelectedDateFrom(date);
        onFilterCountChangeHandle(clone2);
        // reset month and quick filter
        if(fetch) {
            props.setSelectedFilter(clone);
        }
        if(date !== null){
            searchParams.set('created_gte', moment(date).format('YYYY-MM-DD 00:00:00'));
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }else{
            searchParams.delete('created_gte');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
    };

    const selectedDateToHandle = (date,fetch = true) => {

        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if(date === null){
            if(typeof clone.created_lte !== 'undefined'){
                delete clone.created_lte;
            }
            clone2.dateToFilter = false;
            $('.messages_to').removeClass('active');
        } else {
            clone.created_lte = moment(date).format('YYYY-MM-DD 23:59:59');
            $('.messages_to').addClass('active');
            clone2.dateToFilter = true;
        }
        setGlobalFilter(clone);
        setUsedFilterCount(clone2);
        setSelectedDateTo(date);
        onFilterCountChangeHandle(clone2);
        // reset month and quick filter
        if(fetch) {
            props.setSelectedFilter(clone);
        }
        if(date !== null){
            searchParams.set('created_lte', moment(date).format('YYYY-MM-DD 23:59:59'));
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }else{
            searchParams.delete('created_lte');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
    };

    
    const resetFilter = () =>
    {
        selectedDateFromHandle(null, false);
        selectedDateToHandle(null, false);
        let clone = {
            sort: "modified",
            direction: "desc",
            page: 1,
            limit: 100
        };
        setStatusFilter({value: 'all'});
        setNotificationFilter({value: 'all'});
        setSelectedUser(null);
        setSelectedUserGroup(null);
        setUsedFilterCount(cleanState);
        setFilterCount(0);
        setGlobalFilter(clone);
        onFilterCountChangeHandle(cleanState);

        props.setSelectedFilter(clone);
        const newRelativePathQuery = window.location.pathname;
        history.pushState(null, "", newRelativePathQuery);
    }

    const onExportXLS = () => {

        const that = this;
        let params = '', count=0;

        for (var key in globalFilter) {
            if (count > 0) params += '&' + key + '=' + globalFilter[key];
            else params += '?' + key + '=' + globalFilter[key];
            count++;
        }

        const xmlHttp = new XMLHttpRequest();

        xmlHttp.open("GET", getApiHost() + '/users/export'+params, true);

        //  xmlHttp.setRequestHeader('Accept', 'application/json')
        xmlHttp.setRequestHeader('Authorization', 'Bearer ' + Biscuit.get('token'));
        xmlHttp.setRequestHeader('Content-Language', Biscuit.get('user.lang').replace('-','_'));
        xmlHttp.responseType = "blob";

        xmlHttp.onload = function() {
            const blob = new Blob([xmlHttp.response], { type: 'application/xls' });
            FileSaver.saveAs(blob, t("users") + " " + get_today() + ".xlsx");
        };
        xmlHttp.send(null);
    };

    const get_today = () => {
        let today = new Date();
    
        let day = today.getDate(); // Tag
    
        // Monatsangabe startet bei 0!
        let month = today.getMonth()+1; // Monat
    
        let year = today.getFullYear(); // Jahr
        if(day < 10) {
          day = '0'+ day;
        }
        if(month < 10) {
          month = '0'+ month;
        }
        today = day + '.' + month + '.' + year;
    
        return today;
    };
    const onToggleDropdown = (nextShow, meta) => {
        if(nextShow){
            $('.sticky-top-sortbar').addClass('hide');
        } else {
            $('.sticky-top-sortbar').removeClass('hide');
        }
    }

    return (
        <aside
            id="inb-c-sidebar"
            className="resources-sidebar"
            style={{float:'left'}}>
            <header className="inb-c-left-bar__title sticky-top">
                <h1 className="inb-page-title">{t("messages",null,'capital')}</h1>
                 <aside className="inb-c-item__actions" id="asideWidthChange">
                     <DropdownButton id="dropdown-basic-button" title="..." variant="secondary" drop="up-centered" menuAlign="left" align='end'  bsPrefix="button round inb-toggle-contingent-dd hover" onToggle={onToggleDropdown}>
                     <ul className="inb-dropdown__list">
                      <li>
                        <Dropdown.Item href="#" onClick={() => props.setToggleMessage(true)}>
                             <i className="ico-inb inb-fi-map fi fi-page-edit"></i>{t('system_message', null, 'capital')}
                        </Dropdown.Item>
                      </li>
                    </ul>
                  </DropdownButton>
                </aside>
            </header>
            <aside id="inb-selected-filters">
                {filterCount > 0 && <ul>
                    <p>
                        <i className="fi fi-filter"> </i>
                        <span id="inb-selected-filters__count">
                        {" " + filterCount}
                        </span>

                        {" " + t('filter_selected')}
                        <a href="#"
                            id="inb-selected-filters__unset"
                            className="unset-filter"
                            title={t('unselect_all_filter')} onClick={(e) => {
                            resetFilter(e)
                        }}>
                            x
                        </a>
                    </p>
                </ul>}
            </aside>
            <div className="sticky-top-filter">
            {<SidebarFilter
                id="inb-c-left-bar-flist--user-role"
                heading=""
                type="list"
                data={
                    getFilterData( [
                        {name: t('all'), summaryItem: "allCount", value: 'all'},
                        {name: t('message_success'), summaryItem: "successCount", value: 'success'},
                        {name: t('message_failed'), summaryItem: "failedCount", value: 'failed'},
                        {name: t('message_draft'), summaryItem: "draftCount", value: 'draft'},
                        {name: t('message_paused'), summaryItem: "pausedCount", value: 'paused'}
                    ],props.messageSummaryPending,props.messageSummary)
                }
                dataKey="value"
                selected={statusFilter.value}
                summaryPending={props.messageSummaryPending}
                onChangeHandle={onStatusFilterChange}/>}
          {/*  <ul id="inb-c-left-bar-flist--user-role"
                className="inb-vert-list">
                <span className="inb-list-title">
                {t('status')}
                </span>
                <ListItem
                    className={statusFilter.value == 'all' ? 'active' : ''}
                    key={'status_all'}>

                    <span onClick={() => onStatusFilterChange('all')}>
                    {t('all')}
                    </span>
                </ListItem>
              {props.getAvailableStatusMessage().map(status => (
              <ListItem
                  className={status === statusFilter.value ? 'active' : ''}
                  key={status}>

                  <span onClick={() => onStatusFilterChange(status)}>
                    {t('message_' + status)}
                  </span>

                  {statusFilter.value !== null && statusFilter.value !== 'all' && statusFilter.value == status &&
                  <a
                    href="#"
                    className="unset-filter"
                    onClick={() => onStatusFilterChange('all')}
                    title={t('unselect_filter')}>
                    x
                  </a>
                  }
              </ListItem>
              ))}
            </ul>
            */}
            {<SidebarFilter
                id="inb-c-left-bar-flist--user-status"
                heading=""
                type="list"
                data={
                    getFilterData( [
                        {name: t('all'), summaryItem: "allCount", value: 'all'},
                        {name: t('email'), summaryItem: "emailCount", value: 'email'},
                        {name: t('sms'), summaryItem: "smsCount", value: 'sms'},
                        {name: t('push'), summaryItem: "pushCount", value: 'push'}
                    ],props.messageSummaryPending,props.messageSummary)
                }
                dataKey="value"
                selected={notificationFilter.value}
                summaryPending={props.messageSummaryPending}
                onChangeHandle={onNotificationFilterChange}/>}
           {/* <ul id="inb-c-left-bar-flist--user-status"
                className="inb-vert-list">
                <span className="inb-list-title">
                {t('notifications')}
                </span>
              {['all', 'email', 'sms','push'].map(notification => (
              <ListItem
                  className={notification === notificationFilter.value ? 'active' : ''}
                  key={notification}>

                  <span onClick={() => onNotificationFilterChange(notification)}>
                    {t(notification)}
                  </span>

                  {notificationFilter.value !== null && notificationFilter.value !== 'all' && notificationFilter.value == notification &&
                  <a
                    href="#"
                    className="unset-filter"
                    onClick={() => onNotificationFilterChange('all')}
                    title={t('unselect_filter')}>
                    x
                  </a>
                  }
              </ListItem>
              ))}
            </ul>*/}

            <SidebarFilter
                id="inb-c-left-bar-flist--orders-users"
                heading={t('user')}
                type="InboomaSelect"
                sortBy='created'
                sortDirection='desc'
                placeholder={'- ' + t('all', null, 'capital') + ' -'}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                onSelectHandle={onUserSelectHandle}
                dispatch={props.dispatch}
                multiSelect={false}
                advanced={true}
                extraStyle={{width:"700px"}}
            />

            <SidebarFilter
                id="inb-c-left-bar-flist--orders-users"
                heading={t('usergroups')}
                type="select2"
                data={userGroups}
                dataKey="value"
                nameAttribute="label"
                onQueryHandle={onUserGroupQueryHandle}
                onChangeHandle={onUserGroupSelectHandle}
                value={selectedUserGroup}
                model={'membershipType'}
                placeholder={'- ' + t('all', null, 'capital') + ' -'}
            />

            <SidebarFilter
                id="inb-c-left-bar-flist--messages-date"
                heading={t('timespan', null, 'capital')}
                type="datePicker"
                data={[{
                    name: "date_from",
                    className: "noBorders-noBackground",
                    dateFormat: "dd.MM.y",
                    selected: selectedDateFrom,
                    onChangeHandle: selectedDateFromHandle,
                    placeholder: t('valid_from', null, 'capital') + ' ...',
                    extraClassName: "messages_from"
                }, {
                    name: "date_to",
                    className: "noBorders-noBackground",
                    dateFormat: "dd.MM.y",
                    selected: selectedDateTo,
                    onChangeHandle: selectedDateToHandle,
                    placeholder: ' ...' + t('valid_to', null, 'capital'),
                    extraClassName: "messages_to"
            }]}/>
            </div>
            <footer
                className="inb-c-left-bar__footer small-only-float-container"
                    data-inb-action-link="write">
                <a href="#"
                    id="toggle-left-bar"
                    className="button secondary show-for-small-only" onClick={(e) => onToggleLeftBar(e)}>
                        <i className="fi fi-filter"></i>
                        <span className="show-for-sr">{t('open_filter_menu')}</span>
                </a>
            { rbac.hasPermission('write') &&
                <NewMessageButton
                    url={"/usersExtension/messages/add" + currentUrl.search}
                />
            }
            </footer>
        </aside>
    );
};

export default MessageSidebar;